import template from './swag-cms-extensions-custom-form-element-config.html.twig';
import './swag-cms-extensions-custom-form-element-config.scss';

export default {
    template,

    mixins: [
        'cms-element',
    ],

    data() {
        return {
            templateId: null,
            showFormTemplateModal: false,
        };
    },

    computed: {
        formTemplateCriteria() {
            const criteria = new Shopware.Data.Criteria();
            criteria.addFilter(
                Shopware.Data.Criteria.equals('isTemplate', true),
            );

            return criteria;
        },
    },

    watch: {
        templateId() {
            this.$emit('form-template-id-change', this.templateId);
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('custom-form');
        },

        closeFormTemplateModal() {
            this.templateId = null;
            this.showFormTemplateModal = false;
        },

        openFormTemplateModal() {
            this.showFormTemplateModal = true;
        },

        onTemplateUpdated(formTemplate) {
            // If the selected form template got updated reset selection
            if (formTemplate.id === this.templateId) {
                this.templateId = null;
            }
        },
    },
}
